import $ from "jquery";
import { removeSuggestionUploads } from "../components/dropzone";

const $document = $(document);
const $modal = $(".modal");
const $modalBackdrop = $(".modal__backdrop");
const $modalClose = $(".modal__close, .modal-close");

$(function () {
  $document.on("click", ".modal-trigger", function () {
    const $thisEl = $(this);
    const $targetModal = $($thisEl.data("target"));
    openModal($targetModal);
  });
  $modal.on("click", function (event) {
    event.stopImmediatePropagation();
  });
  $modalBackdrop.on("click", function () {
    const $thisEl = $(this);
    const $targetModal = $thisEl.find(".modal");
    closeModal($targetModal);
  });
  $modalBackdrop.on("keydown", function (e) {
    if (e.key === "Escape") {
      const $thisEl = $(this);
      const $targetModal = $thisEl.find(".modal");
      closeModal($targetModal);
    }
  });
  $modalClose.on("click", function () {
    const $thisEl = $(this);
    const $targetModal = $thisEl.closest(".modal");
    closeModal($targetModal);
  });
});

function openModal(targetModal) {
  if (targetModal !== undefined) {
    if (targetModal.is(":hidden")) {
      targetModal.closest(".modal__backdrop").addClass("active");
      targetModal.fadeIn(200);
    }
  }
  
  $("#frm-suggestion-form-first_name").focus();
  removeSuggestionUploads();
}

function closeModal(targetModal) {
  if (targetModal !== undefined) {
    if (targetModal.is(":visible")) {
      targetModal.closest(".modal__backdrop").removeClass("active");
      targetModal.fadeOut(200);
    }
  }

  removeSuggestionUploads();
}
